import { EditIcon, Group } from '@/components/_common';
import ActionIcon from '@/components/_common/ActionIcon';
import { useDisclosure } from '@/hooks';
import { Button, Col, Row, Table } from 'antd';
import CompanyResourceAvaiableFormModal from './CompanyResourceAvaiableFormModal';
import { useCompanyAvailabilityList } from '@/core/domain/enterprise/company-availability/company-availability.hooks';
import { useCompanyFormContext } from '@/components/Companies/CompaniesFormProvider';
import {
  CompanyAvailability,
  CompanyAvailabilityDayOfWeek,
  CompanyAvailabilityDayOfWeekLabel,
} from '@/core/domain/enterprise/company-availability/company-availability.types';
import CompanyResourceAvaiableRemove from './CompanyResourceAvaiableRemove';
import { useState } from 'react';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

export default function CompanyResourceAvaiable() {
  const [itemEdit, setItemEdit] = useState<CompanyAvailability>();

  const [opened, action] = useDisclosure(false, {
    onClose: () => setItemEdit(undefined),
  });

  const { companyId } = useCompanyFormContext();

  const companyAvailabilityList = useCompanyAvailabilityList({ companyId });

  const formatHours = (value: string) => value.replace('.', ':');

  const hasCreatePermission = hasPermissions([
    Authorities.COMPANY_AVAILABILITY_ADD,
  ]);
  const hasEditPermission = hasPermissions([
    Authorities.COMPANY_AVAILABILITY_EDIT,
  ]);

  return (
    <>
      <Row justify="end" style={{ marginBottom: 24 }}>
        <Col>
          <Button
            type="primary"
            onClick={action.open}
            disabled={!hasCreatePermission}
          >
            Adicionar disponibilidade
          </Button>
        </Col>
      </Row>

      <Table
        dataSource={companyAvailabilityList.data}
        scroll={{ x: true }}
        columns={[
          {
            title: 'Dia da semana',
            dataIndex: 'dayOfWeek',
            render: (value: CompanyAvailabilityDayOfWeek) =>
              CompanyAvailabilityDayOfWeekLabel[value],
          },
          {
            title: 'Horário de funcionamento',
            render: (_, item) =>
              `${formatHours(item.openingHour)} ~ ${formatHours(
                item.closingHour,
              )}`,
          },
          {
            title: 'Horário de intervalo',
            render: (_, item) =>
              item.intervalOpeningHour && item.intervalClosingHour ? (
                `${formatHours(item.intervalOpeningHour)} ~ ${formatHours(
                  item.intervalClosingHour,
                )}`
              ) : (
                <span style={{ color: 'darkgray' }}>Sem horário</span>
              ),
          },
          {
            title: 'Recursos disponíveis',
            dataIndex: 'capacity',
            align: 'right',
            render: (value) => (value === 0 ? 'Todos os recursos' : value),
          },
          {
            title: 'Ação',
            align: 'right',
            fixed: 'right',
            render: (_, item) => (
              <Group gap={10} position="right">
                <ActionIcon
                  onClick={() => {
                    setItemEdit(item);
                    action.open();
                  }}
                  disabled={!hasEditPermission}
                >
                  <EditIcon />
                </ActionIcon>

                <CompanyResourceAvaiableRemove item={item} />
              </Group>
            ),
          },
        ]}
        pagination={false}
      />

      <CompanyResourceAvaiableFormModal
        opened={opened}
        onClose={action.close}
        item={itemEdit}
        disableDayOfWeek={companyAvailabilityList.data?.map(
          (item) => item.dayOfWeek,
        )}
      />
    </>
  );
}
